import $ from 'jquery';

Drupal.behaviors.siwertellMenuSuperSub = {
  attach: function (context) {
    const $element = $('.primary-menu-super-sub__row', context);
    const $block = $element.closest('ul');
    const $wrapper = $block.closest('li');

    $block.addClass('primary-menu-super-sub');
    $wrapper.addClass('has-super-sub');
  }
};
